import React, { useState } from 'react';
import { adjustInventoryItemUnfufilledQuantity } from 'services';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AdjustItemUnfulfilledQuantityModal = props => {
  const { itemId, itemQuantity, onSuccess, toggleModal } = props;
  const [reason, setReason] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [quantity, setQuantity] = useState<string>(itemQuantity);

  const adjustInventoryItemQuantityFn = async () => {
    setLoading(true);
    try {
      await adjustInventoryItemUnfufilledQuantity(itemId, parseInt(quantity), reason);
      await onSuccess();
      showSuccess('Unfulfilled quantity updated successfully.');
      toggleModal();
    } catch (e) {
      showError(e);
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Inventory Item</div>
            <div className={styles['modal-title']}>Adjust Inventory Item Unfulfilled Quantity</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Unfulfilled Quantity</div>
            <input
              type={'number'}
              value={quantity}
              className={'form-control'}
              onChange={e => setQuantity(e.target.value)}
            />
          </div>
          <div>
            <div className={styles['label']}>Reason</div>
            <input
              value={reason}
              className={'form-control'}
              onChange={e => setReason(e.target.value)}
            />
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={adjustInventoryItemQuantityFn}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdjustItemUnfulfilledQuantityModal;
